import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// Produtos
export const getProducts = () => api.get('/products');
export const getProduct = (id: string) => api.get(`/products/${id}`);
export const createProduct = (productData: any) => api.post('/products', productData);
export const updateProduct = (id: string, productData: any) => api.patch(`/products/${id}`, productData);
export const deleteProduct = (id: string) => api.delete(`/products/${id}`);

// Leads
export const getLeads = () => api.get('/leads');
export const getLead = (id: string) => api.get(`/leads/${id}`);
export const createLead = (leadData: any) => api.post('/leads', leadData);
export const updateLead = (id: string, leadData: any) => api.patch(`/leads/${id}`, leadData);
export const updateLeadStatus = (id: string, status: string) => api.patch(`/leads/${id}/status`, { status });
export const deleteLead = (id: string) => api.delete(`/leads/${id}`);
export const getLeadStats = () => api.get('/leads/stats/overview');

// Postagens em Redes Sociais
export const getPosts = () => api.get('/social');
export const getPost = (id: string) => api.get(`/social/${id}`);
export const createPost = (postData: any) => api.post('/social', postData);
export const updatePost = (id: string, postData: any) => api.patch(`/social/${id}`, postData);
export const deletePost = (id: string) => api.delete(`/social/${id}`);
export const publishPost = (id: string) => api.post(`/social/${id}/publish`);
export const getTodayPosts = () => api.get('/social/scheduled/today');

// IA
export const getProductRecommendations = (prompt: string) => api.post('/ai/recommendations/products', { prompt });
export const getLeadRecommendations = (prompt: string) => api.post('/ai/recommendations/leads', { prompt });
export const improveTextWithAI = (text: string, type: 'email' | 'whatsapp' | 'social') => 
  api.post('/ai/improve-text', { text, type });

export default api; 